import { 
 
    CONSULTAR_API_PRESTADORES,
    JSON_RESPUESTA_API,
    DATOS_METODO_PRESTADOR,
    RESPUESTA_API_PRESTADORES
} from '../../Types';

export default ( state, action ) => {

    switch(action.type){
        
        case CONSULTAR_API_PRESTADORES:
            return{
                ...state,
                consulta_prestadores: action.payload
            }

        case JSON_RESPUESTA_API:
            return{
                ...state,
                json_resp: action.payload
            }

        case DATOS_METODO_PRESTADOR:
            return{
                ...state,
                datos_metodo_prestador: action.payload
            }

        case RESPUESTA_API_PRESTADORES:
            return{
                ...state,
                respuesta_api_prestadores: action.payload
            }
            

        default:
            return state;
    }

}